// extracted by mini-css-extract-plugin
export default {"wrapper":"Z78ds m2rwA","wide":"dzkXi"};